import React, {Component} from 'react';
import moment from 'moment';
import {translate} from 'react-i18next';

import PageHeader from '../elements/PageHeader';

class OverviewScreen extends Component {

    componentDidMount() {
        this.props.getProjectOverview();
        this.props.getCampingStats();
    }

    render() {
        const {t, projectOverview, campingStats} = this.props;
        const pct = (n, total) => total > 0 ? Math.round(n / total * 100) : 0;
        const projected = (count, notSetCount, total) => {
            const totalSet = total - notSetCount;
            return totalSet > 0 ? Math.round(count / totalSet * total) : 0;
        };
        return (
            <div className="OverviewScreen">
                <PageHeader title={t('overview.title', {username: this.props.username})}/>
                <div className="wrapper wrapper-content">
                    {projectOverview ? (
                        <div>
                            <div className="row m-b-sm">
                                <div className="col-xs-12">
                                    <h2>
                                        {t('project.name.' + projectOverview.name)}
                                    </h2>
                                </div>
                            </div>
                            {projectOverview.stats ? (
                                <div className="row m-t">
                                    <div className="col-xs-12">
                                        <div className="ibox">
                                            <div className="ibox-content">
                                                <div className="row">
                                                    <div className="col-xs-2">
                                                        <div>
                                                            <h4>
                                                                {projectOverview.stats.applications}
                                                            </h4>
                                                            <strong>
                                                                {t('applicationScreen.stats.applications.title')}
                                                            </strong>
                                                            <p>
                                                                <small>
                                                                    {t('applicationScreen.stats.applications.text')}
                                                                </small>
                                                            </p>
                                                        </div>
                                                        <div className="m-t-md">
                                                            <h4>
                                                                {projectOverview.stats.invited}
                                                            </h4>
                                                            <strong>
                                                                {t('applicationScreen.stats.invited.title')}
                                                            </strong>
                                                            <p>
                                                                <small>
                                                                    {t('applicationScreen.stats.invited.text')}
                                                                </small>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <h4>
                                                            {projectOverview.stats.accepted}
                                                        </h4>
                                                        <strong>
                                                            {t('applicationScreen.stats.accepted.title')}
                                                        </strong>
                                                        <p>
                                                            <small>
                                                                {t('applicationScreen.stats.accepted.text')}
                                                            </small>
                                                        </p>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <h4>
                                                            {projectOverview.stats.not_accepted}
                                                        </h4>
                                                        <strong>
                                                            {t('applicationScreen.stats.not_accepted.title')}
                                                        </strong>
                                                        <p>
                                                            <small>
                                                                {t('applicationScreen.stats.not_accepted.text')}
                                                            </small>
                                                        </p>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <h4>
                                                            {projectOverview.stats.denied}
                                                        </h4>
                                                        <strong>
                                                            {t('applicationScreen.stats.denied.title')}
                                                        </strong>
                                                        <p>
                                                            <small>
                                                                {t('applicationScreen.stats.denied.text')}
                                                            </small>
                                                        </p>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <h4>
                                                            {projectOverview.stats.may_reactivate}
                                                        </h4>
                                                        <strong>
                                                            {t('applicationScreen.stats.may_reactivate.title')}
                                                        </strong>
                                                        <p>
                                                            <small>
                                                                {t('applicationScreen.stats.may_reactivate.text')}
                                                            </small>
                                                        </p>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <h4>
                                                            {projectOverview.stats.may_registrate}
                                                        </h4>
                                                        <strong>
                                                            {t('applicationScreen.stats.may_registrate.title')}
                                                        </strong>
                                                        <p>
                                                            <small>
                                                                {t('applicationScreen.stats.may_registrate.text')}
                                                            </small>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <div className="row m-t">
                                {projectOverview.periods.map((period, i) => (
                                    <div className="col-xs-6 col-md-3" key={i}>
                                        <div className="ibox">
                                            <div className="ibox-content">
                                                <h5>{t('default.period.' + period.name, {
                                                    startAt: moment(period.startAt).format('DD.MM.'),
                                                    endAt: moment(period.endAt).format('DD.MM.')
                                                })}</h5>
                                                <h1 className="no-margins m-t-sm">{period.supporterProjectsAmount}/{period.slots}</h1>

                                                <small>
                                                    <i className="fa fa-ticket m-r-xs" title={t('overview.project.period.supporterTicketsDownloadedAmount')}/>{period.supporterTicketsDownloadedAmount}
                                                </small>
                                                {period.stewardsNeeded ? (
                                                    <small className="m-l-md">
                                                        <i className="fa fa-shield m-r-xs" title={t('overview.project.period.supporterStewardFormReceivedAmount')}/>{period.supporterStewardFormReceivedAmount}
                                                    </small>
                                                ) : null}
                                                {period.availableForBottleDeposit ? (
                                                    <small className="m-l-md">
                                                        <i className="fa fa-glass m-r-xs" title={t('overview.project.period.supporterStewardFormReceivedAmount')}/>{period.availableForBottleDepositAmount}
                                                    </small>
                                                ) : null}
                                                <div className="m-t-sm">
                                                    {period.slotsReallyNeeded ? (
                                                        <div>
                                                            <div className="stat-percent font-bold text-navy">
                                                              {period.slotsReallyNeeded}
                                                            </div>
                                                            <small>{t('overview.project.period.slotsReallyNeeded')}</small>
                                                        </div>
                                                    ) : null}
                                                    <div>
                                                        <div className={"stat-percent font-bold text-" + (parseInt((period.supporterProjectsAmount / (period.slotsReallyNeeded ? period.slotsReallyNeeded : period.slots)) * 100, 10) < 100 ? 'warning' : 'navy')}>
                                                            {parseInt((period.supporterProjectsAmount / (period.slotsReallyNeeded ? period.slotsReallyNeeded : period.slots)) * 100, 10)}
                                                            <i className="fa fa-percent"/>
                                                        </div>
                                                        <small>{t('overview.project.period.amount')}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="col-xs-6 col-md-3">
                                    <div className="ibox">
                                        <div className="ibox-content yellow-bg">
                                            <h5>{t('default.period.none')}</h5>
                                            <h1 className="no-margins m-t-sm">{projectOverview.validSupporterProjectsWithoutPeriodAmount}</h1>
                                            <div className="m-t-sm">
                                                <div className="stat-percent font-bold">&nbsp;</div>
                                                <small>&nbsp;</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {campingStats && campingStats.arrivalType ? (
                                <div className="row m-t">
                                    <div className="col-xs-12">
                                        <div className="ibox">
                                            <div className="ibox-title">
                                                <h5>{t('overview.campingStats.title')}</h5>
                                            </div>
                                            <div className="ibox-content">
                                                <div className="row">
                                                    <div className="col-xs-4">
                                                        <strong>{t('supporterProject.arrivalType.label')}</strong>
                                                        <table className="table table-condensed m-t-sm">
                                                            <tbody>
                                                                <tr><td>{t('supporterProject.arrivalType.CAR')}</td><td>{campingStats.arrivalType.CAR}</td><td className="text-muted">{pct(campingStats.arrivalType.CAR, campingStats.totalValidSupporters - campingStats.arrivalType.notSet)}%</td><td className="text-muted">~{projected(campingStats.arrivalType.CAR, campingStats.arrivalType.notSet, campingStats.totalValidSupporters)}</td></tr>
                                                                <tr><td>{t('supporterProject.arrivalType.PUBLIC_TRANSPORT')}</td><td>{campingStats.arrivalType.PUBLIC_TRANSPORT}</td><td className="text-muted">{pct(campingStats.arrivalType.PUBLIC_TRANSPORT, campingStats.totalValidSupporters - campingStats.arrivalType.notSet)}%</td><td className="text-muted">~{projected(campingStats.arrivalType.PUBLIC_TRANSPORT, campingStats.arrivalType.notSet, campingStats.totalValidSupporters)}</td></tr>
                                                                <tr><td>—</td><td>{campingStats.arrivalType.notSet}</td><td></td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-xs-4">
                                                        <strong>{t('supporterProject.sleepingArrangement.label')}</strong>
                                                        <table className="table table-condensed m-t-sm">
                                                            <tbody>
                                                                <tr><td>{t('supporterProject.sleepingArrangement.CAR')}</td><td>{campingStats.sleepingArrangement.CAR}</td><td className="text-muted">{pct(campingStats.sleepingArrangement.CAR, campingStats.totalValidSupporters - campingStats.sleepingArrangement.notSet)}%</td><td className="text-muted">~{projected(campingStats.sleepingArrangement.CAR, campingStats.sleepingArrangement.notSet, campingStats.totalValidSupporters)}</td></tr>
                                                                <tr><td>{t('supporterProject.sleepingArrangement.CAMPER')}</td><td>{campingStats.sleepingArrangement.CAMPER}</td><td className="text-muted">{pct(campingStats.sleepingArrangement.CAMPER, campingStats.totalValidSupporters - campingStats.sleepingArrangement.notSet)}%</td><td className="text-muted">~{projected(campingStats.sleepingArrangement.CAMPER, campingStats.sleepingArrangement.notSet, campingStats.totalValidSupporters)}</td></tr>
                                                                <tr><td>{t('supporterProject.sleepingArrangement.TENT')}</td><td>{campingStats.sleepingArrangement.TENT}</td><td className="text-muted">{pct(campingStats.sleepingArrangement.TENT, campingStats.totalValidSupporters - campingStats.sleepingArrangement.notSet)}%</td><td className="text-muted">~{projected(campingStats.sleepingArrangement.TENT, campingStats.sleepingArrangement.notSet, campingStats.totalValidSupporters)}</td></tr>
                                                                <tr><td>—</td><td>{campingStats.sleepingArrangement.notSet}</td><td></td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-xs-4">
                                                        <strong>{t('supporterProject.preferredBackstage.label')}</strong>
                                                        <table className="table table-condensed m-t-sm">
                                                            <tbody>
                                                                {(() => {
                                                                    const notSetCount = campingStats.preferredBackstage.find(x => x.id === null)?.count ?? 0;
                                                                    return campingStats.preferredBackstage.map((b, i) => (
                                                                        <tr key={i}>
                                                                            <td>{b.id === null ? '—' : b.name}</td>
                                                                            <td>{b.count}</td>
                                                                            <td className="text-muted">{b.id !== null ? pct(b.count, campingStats.totalValidSupporters - notSetCount) + '%' : ''}</td>
                                                                            <td className="text-muted">{b.id !== null ? '~' + projected(b.count, notSetCount, campingStats.totalValidSupporters) : ''}</td>
                                                                        </tr>
                                                                    ));
                                                                })()}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <small className="text-muted">{t('overview.campingStats.total')}: {campingStats.totalValidSupporters}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    ) : null }
                  {/*<div className="hr-line-dashed"/>
                    Falls Fehler auftreten, bitte an <a href="mailto:staging@nilssonsound.de">staging@nilssounsound.de</a> wenden.
                    <br/><br/><br/>
                    <b>Neulich hinzugefügt</b>
                    <ul>
                        <li>
                            fusion-supporter-backend-0.9.3
                            <ul>
                                <li>
                                    Runner-Tablet-Ansicht
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.9.2
                            <ul>
                                <li>
                                    Supporter:innen-Ansicht: Checkbox für Turnbeutel
                                </li>
                                <li>
                                    Check-Out: Ceckbox für Turnbeutel
                                </li>
                                <li>
                                    Runner-Tablet-Ansicht (beta)
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.9.1
                            <ul>
                                <li>
                                    Check-In: Checkbox für Auto-Sticker und Elektro-Bier
                                </li>
                                <li>
                                    Check-Out
                                </li>
                                <li>
                                    Supporter:innen-Ansicht: Zeige an, ob bereit für Check-Out und Button zum Checkout
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.9.0
                            <ul>
                                <li>
                                    Anzeigen (und Drucken) aller Routen inklusive Schichten für bestimmten, frei wählbaren Zeitraum
                                </li>
                                <li>
                                    Checkbox "Alle Essensmarken bekommen" beim Check-In für Supporter:innen mit dem Zeitraum "wähend dem Festival"
                                </li>
                                <li>
                                    Info-Text für A5-Handout für Supporter:innen mit dem Zeitraum "nach dem Festival"
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.8.6
                            <ul>
                                <li>
                                    Drucken der Einsatzort-Infos inkl. Schichtübersicht
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.8.5
                            <ul>
                                <li>
                                    A5-Handout nochmals drucken (in Kasse und Supporter:innen-Profil)
                                </li>
                                <li>
                                    Kasse: Ausgewähltes Ticket schließen
                                </li>
                                <li>
                                    Layoutanpassungen A5-Handout
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.8.4
                            <ul>
                                <li>
                                    Automatisches Drucken des A5-Handouts für Supporter:innen nach dem Check-In
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.8.3
                            <ul>
                                <li>
                                    Routenverwaltung
                                </li>
                                <li>
                                    Anpassungen Einsatzort-Bearbeitung
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.8.1
                            <ul>
                                <li>
                                    Elektro-Bier-Checkbox
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.8.0
                            <ul>
                                <li>
                                    Verwaltung Arbeitsbereiche
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.11
                            <ul>
                                <li>
                                    Anpassungen Kasse
                                </li>
                                <li>
                                    Stapelverarbeitung: Supporter:innen daran erinnern, ihre Schichten zu bestätigen, falls noch nicht gemacht
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.10
                            <ul>
                                <li>
                                    Schicht eines/r Supporters/in durch andere zur gleichen Zeit ersetzen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.9
                            <ul>
                                <li>
                                    Gruppen-Ansicht an allen nötigen Stellen
                                </li>
                                <li>
                                    Schichtplan: Anzeige, wie viele Supporter:innen pro Schicht schon eingecheckt haben
                                </li>
                                <li>
                                    Manuelle Eingabe der Ticket-Nummer falls nicht scannbar
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.8
                            <ul>
                                <li>
                                    Button in Supporter-Veranstaltungs-Ansicht: Hat Autosticker bekommen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.7
                            <ul>
                                <li>
                                    Button in Supporter-Ansicht: Geänderte Schichten in das Profil übertragen und per Mail benachrichtigen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.6
                            <ul>
                                <li>
                                    Schichtplan initial zum aktuellen Datum scrollen
                                </li>
                                <li>
                                    Nur Schichten vorschlagen, welche nicht in der Vergangenheit liegen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.5
                            <ul>
                                <li>
                                    Schicht eines/r Supporters/in durch andere ersetzen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.4
                            <ul>
                                <li>
                                    Direkte Verlinkung Schicht zu Supporter und zurück
                                </li>
                                <li>
                                    Öffnen der Schicht-Detailansicht ohne Doppelklick
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.3
                            <ul>
                                <li>
                                    Logbuch
                                </li>
                                <li>
                                    Stapelverarbeitung: Absage der Supporter_innen des Arbeitszeitraums pre1 und noch nicht eingecheckt
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.2
                            <ul>
                                <li>
                                    Schicht-Status (CONFIRMED, CHECKED_IN, CANCELLED, CHECKED_OUT) und Essensmarken pro Schicht setzen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.1
                            <ul>
                                <li>
                                    Kassensystem Erweiterung inkl. Kassenbericht
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.7.0
                            <ul>
                                <li>
                                    Kassensystem (rudimentär)
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.7
                            <ul>
                                <li>
                                    Benutzerverwaltung (Admins)
                                </li>
                                <li>
                                    Schicht-Anlage: Kommentar hinzufügen
                                </li>
                                <li>
                                    Schichtplan-Übersicht: Kommentar-Icon, falls Kommentare vorhanden
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.6
                            <ul>
                                <li>
                                    Kommentare zu Schichten hinzufügen und löschen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.5
                            <ul>
                                <li>
                                    Schichten löschen
                                </li>
                                <li>
                                    Stapelverarbeitung: Alle Supporter:innen externer Crews bitten, Teilnahme zu bestätigen (können dann Tickets herunterladen)
                                </li>
                                <li>
                                    Stapelverarbeitung: Alle Supporter:innen mit dem Arbeitszeitram während des Festivals bitten, Teilnahme zu bestätigen (können dann Tickets herunterladen)
                                </li>
                                <li>
                                    Verbessertes vertikales Scrolling Schichtplan
                                </li>
                                <li>
                                    Notfall/Logout-Shortcut: [ctrl] + [l] (Steuerung und kleines L drücken)
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.4
                            <ul>
                                <li>
                                    Schicht-Detail-Ansicht (inkl. bearbeiten und Supporter-Verwaltung)
                                </li>
                                <li>
                                    Farbige Anzeige der Schichten in der Übersicht (nach Belegung)
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.3
                            <ul>
                                <li>
                                    Supporter:innen von Schichten entfernen
                                </li>
                                <li>
                                    Anzeigen der bevorzugten Arbeitsbereiche in der Supporter:innen-Ansicht
                                </li>
                                <li>
                                    Anzeigen der Gruppe in der Supporter:innen-Ansicht
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.2
                            <ul>
                                <li>
                                    Supporter:innen zu Schichten einteilen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.1
                            <ul>
                                <li>
                                    Schichten anlegen
                                </li>
                                <li>
                                    Einsatzorte anlegen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.6.0
                            <ul>
                                <li>
                                    Schichtplan (Ansicht)
                                </li>
                                <li>
                                    Import des Schichtplans
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.5.5
                            <ul>
                                <li>
                                    Stapelverarbeitung: Alle Supporter:innen des letzten Arbeitszeitraums bitten, Teilnahme zu bestätigen (können dann Tickets herunterladen)
                                </li>
                                <li>
                                    Supporter-Detail-Ansicht: Kommentare löschen, wenn selbst erstellt und nicht älter als 4 Wochen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.5.4
                            <ul>
                                <li>
                                    Supporter-Detail-Ansicht: Anzeigen, wann Ticket heruntergeladen wurde
                                </li>
                                <li>
                                    Supporter-Detail-Ansicht: Kommentare anzeigen und erstellen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.5.3
                            <ul>
                                <li>
                                    Supporter-Detail-Ansicht: Status ob Teilnahme bestätigt, wenn ja kann das Ticket heruntergeladen werden
                                </li>
                                <li>
                                    Stapelverarbeitung: Alle Supporter des ersten Arbeitszeitraums bitten, Teilnahme zu bestätigen (können dann Tickets herunterladen)
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.5.2
                            <ul>
                                <li>
                                    Verbesserung der Wartelisten: Filtern nach aktuellem Wartezeitraum und suche nach Mailadresse sind nun möglich
                                </li>
                                <li>
                                    Ablaufdatum der Best Friends Ticket Option: Heute Abend um 23:59 wird die Option des vergebens der BFT automatisch abgeschaltet
                                </li>
                                <li>
                                    Statistiken auf der Startseite
                                </li>
                                <li>
                                    Stapelverarbeitung kann jetzt nur noch von Admin Accounts ausgeführt werden
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.5.1
                            <ul>
                                <li>
                                    Serien-Aktion: Mail an Supporter welche ein Best Friend Ticket eintragen dürfen, es aber noch nicht getan haben
                                </li>
                                <li>
                                    Fix: Supporter-Ansicht: Best Friend Ticket Option aktivieren/deaktivieren
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.5.0
                            <ul>
                                <li>
                                    Serien-Aktion: Best Friend Ticket für Supporter aktivieren, welche die Fusion 2016 erfolgreich abgeschlossen haben und für dieses Jahr CONFIRMED sind.
                                </li>
                                <li>
                                    Supporter-Ansicht: Best Friend Ticket Option aktivieren/deaktivieren und Best Friend anzeigen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.4.5
                            <ul>
                                <li>
                                    Ein-/Ausklappen der Wartelisten
                                </li>
                                <li>
                                    Serien-Aktion: Supportern absagen, welche noch keinen Zeitraum ausgewählt haben
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.4.4
                            <ul>
                                <li>
                                    Passwort-Zurücksetzen-Token an Supporter schicken
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.4.3
                            <ul>
                                <li>
                                    Wartelisten filtern, Supporter davon entfernen, Supporter in den gewünschten Zeitraum setzen
                                </li>
                                <li>
                                    Aborted-Prozedur anpassen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.4.2
                            <ul>
                                <li>
                                    Supporter anlegen
                                </li>
                                <li>
                                    Supporter-Password setzen
                                </li>
                                <li>
                                    Wartelisten anzeigen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.4.1
                            <ul>
                                <li>
                                    Arbeitszeiträume in Supporter-Liste mit Daten anzeigen, nicht Name
                                </li>
                                <li>
                                    E-Mail-Adressen in Supporter-Liste anzeigen und suchbar machen
                                </li>
                                <li>
                                    Supporter-Absage vom Backend ermöglichen
                                </li>
                                <li>
                                    Anzeigen der Events der Supporter in der Detailansicht
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.4.0
                            <ul>
                                <li>
                                    Profil (Benutzername und Passwort ändern)
                                </li>
                                <li>
                                    Datepicker bei Supporter Geburtstag
                                </li>
                                <li>
                                    Datum der Arbeitszeiträume anzeigen
                                </li>
                                <li>
                                    Fix: Name der Supporter nicht änderbar
                                </li>
                                <li>
                                    kleinere Verbesserungen
                                </li>
                            </ul>
                        </li>
                        <li>
                            fusion-supporter-backend-0.3.1
                            <ul>
                                <li>
                                    Supporter-Detail-Ansicht: Anzeigen und Ändern der Daten zum aktuellen Projekt (Arbeitszeitraum, Status)
                                </li>
                                <li>
                                    Supporter-Detail-Ansicht: Anzeigen und Ändern der Daten des Notfallkontakts
                                </li>
                                <li>
                                    Supporter-Detail-Ansicht: Anzeigen und Ändern der Handycaps
                                </li>
                            </ul>
                        </li>
                    </ul>*/}
                </div>
            </div>
        )
    }
}

export default translate()(OverviewScreen);
